import { render, staticRenderFns } from "./ContractInput.vue?vue&type=template&id=5b86cb10&scoped=true"
import script from "./ContractInput.vue?vue&type=script&lang=js"
export * from "./ContractInput.vue?vue&type=script&lang=js"
import style0 from "./ContractInput.vue?vue&type=style&index=0&id=5b86cb10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b86cb10",
  null
  
)

export default component.exports